// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import { isUndefined } from 'lodash';

export interface IDataItems {
  registeredUsers: number;
  notVerifiedUsers: number;
  totalUsers: number;
  incomingMessagesWithErrors: number;
  technicalErrorMessages: number;
  activeRegistrations: number;
  excludedRegistrations: number;
  newRegistrations: number;
  updateRequests: number;
  totalRegistrations: number;
  activeVatReturns: number;
  newVatReturns: number;
  submittedVatReturns: number;
  vatReturnsWithErrors: number;
  totalVatReturns: number;
  vatAmountDeclared: number;
  payableAmount: number;
  amountPaid: number;
  amountAllocated: number;
}

export interface IDataTraderItems {
  registration: {
    commencementDate: string;
    registrationDate: string;
    registrationStatusDesc: string;
  };
  payments: {
    paymentAmountPending: number;
    totalAmountAllocated: number;
    totalAmountPaid: number;
  };
  vat: {
    countVatReturn: number;
    totalAmountsDeclared: number;
    totalAmountsPayable: number;
  };
}

export interface IDataItemsAnalytics {
  amtTotal: number;
  monthYear: string;
}

export interface IAdminDashboardDataOutput {
  adminKPIs: IDataItems;
  vatAmountDeclaredAnalytics: Array<IDataItemsAnalytics>;
  payableAmountAnalytics: Array<IDataItemsAnalytics>;
  amountPaidAnalytics: Array<IDataItemsAnalytics>;
  amountAllocatedAnalytics: Array<IDataItemsAnalytics>;
  filters: IAdminDashboardDataInput;
}

export interface IAdminDashboardDataInput {
  schemeType?: string;
  periodLength?: string;
}

export const fetchAdminDashboardData = async (
  payload: IAdminDashboardDataInput
): Promise<Types.ResponseOutput> => {
  let queryData = '?';
  if (payload.schemeType) {
    queryData = queryData + `schemeType=${payload.schemeType}&`;
  }
  if (payload.periodLength) {
    queryData = queryData + `periodLength=${payload.periodLength}`;
  } else {
    queryData = queryData + `periodLength=3`;
  }
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/admin-dashboard/admin${queryData}`
  );

  let _data: IAdminDashboardDataOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface ITraderDashboardDataOutput {
  traderKpis: IDataTraderItems;
  applicantTypeId: number;
  vatNotSubmitted: number;
}

export const fetchTraderDashboardData =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/admin-dashboard/trader`
    );

    let _data: ITraderDashboardDataOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };
